import { AgGridReact } from "ag-grid-react"
import PropTypes from "prop-types"
import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import { Link, withRouter } from "react-router-dom"
import { Button, Image, Input, Segment, Checkbox } from "semantic-ui-react"
import HighlightIcon from "../../assets/images/HighlightIcon.png"
import { FIELD_AWAITING_APPROVAL_COUNT, FLEETCOR } from "../../constants/application"
import { agGridColumnDefs, agGridRowData } from "../../constants/fleets"
import { NOTIFICATION_TYPE } from "../../constants/notification"
import { navigationPaths } from "../../constants/paths"
import { isFleetAdvise } from "../../helpers/affiliationHelpers"
import * as agGridHelpers from "../../helpers/agGridHelpers"
import FMCTransactionsShimmer from "../../views/accounts/FMCTransactionsShimmer"
import CustomLoadingOverlay from "../shared/CustomLoadingOverlay"
import CustomNoRowsOverlay from "../shared/CustomNoRowsOverlay"
import CustomNotification from "../shared/CustomNotification"
import { getSubdomain } from "../shared/StylesheetInjector"

class FleetList extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1,
      prevBottomDisplayedRowIndex: 0,
      search_text: "",
      searchByAccountNumber: false
    }
    this.wrapperRef = React.createRef()
  }

  static propTypes = {
    fleets: PropTypes.array.isRequired
  }

  handleNavigateToServicePage = async (fleetId) => {
    const { dispatch } = this.props
    dispatch({
      type: "SERVICES_AWAITING_APPROVAL_FLAG",
      payload: { render_active_order_tab: true, fleetId }
    })
  }

  setFilteredItems = () =>
    this.setState({ filteredItems: this.api.getModel().rowsToDisplay.map((r) => r.data) })

  handleNavigate = () => {
    this.props.dispatch({
      type: "SERVICES_AWAITING_APPROVAL_FLAG",
      payload: { render_active_order_tab: false }
    })
  }

  defaultCellRenderer = (cellParams) => {
    const {
      data,
      colDef: { field }
    } = cellParams
    const fleetId = data.id
    const fleetAdvise = isFleetAdvise()

    return data.awaiting_approval_count > 0 && field === FIELD_AWAITING_APPROVAL_COUNT ? (
      <Link
        className={"ag-grid-link-column"}
        to={navigationPaths.servicesIndex()}
        onClick={() => this.handleNavigateToServicePage(fleetId)}
      >
        <div className={fleetAdvise ? "fleet-highlight" : "fleet-list-highlight"}>
          {fleetAdvise ? <Image src={HighlightIcon} /> : null}
          {cellParams.value}
        </div>
      </Link>
    ) : (
      <Link
        className={"ag-grid-link-column"}
        to={navigationPaths.fleetEdit(fleetId)}
        onClick={this.handleNavigate}
      >
        <div>{cellParams.value}</div>
      </Link>
    )
  }

  resetFiltering = () => this.api.setFilterModel([])

  onGridReady = (params) => {
    this.api = params.api
    this.columnApi = params.columnApi
  }

  handlePageChange = async ({ newPage }) => {
    const { dispatch } = this.props
    if (newPage) {
      this.api.showLoadingOverlay()
      if (this.state.search_text) {
        dispatch({
          type: "FLEETS_LOAD_SAGA",
          payload: {
            page: newPage,
            query: this.state.search_text,
            filter: {
              filterType: "search_type",
              filterValue: this.state.selectedOption
            }
          },
          callback: this.afterLoadServices
        })
      } else {
        dispatch({
          type: "FLEETS_LOAD_SAGA",
          payload: {
            page: newPage,
            pagination: true
          },
          callback: this.afterLoadServices
        })
      }
    }
    this.setState({ page: newPage })
  }

  afterLoadServices = (message) => {
    this.api.hideOverlay()
  }

  onTextChange = (event) => {
    const { dispatch } = this.props
    this.setState({ search_text: event.target.value })

    if (event.target.value == "") {
      this.api.showLoadingOverlay()
      dispatch({
        type: "FLEETS_LOAD_SAGA",
        payload: {
          page: 1,
          pageLoad: "false"
        },
        callback: this.afterLoadServices
      })
    }
  }

  onSearch = () => {
    const { t } = this.props
    if (this.state.search_text !== "" && this.state.search_text.length >= 3) {
      const { dispatch } = this.props
      this.api.showLoadingOverlay()
      dispatch({
        type: "FLEETS_LOAD_SAGA",
        payload: {
          page: 1,
          query: this.state.search_text,
          searchByAccountNumber: this.state.searchByAccountNumber,
          filter: {
            filterType: "seach_type",
            filterValue: this.state.selectedOption
          }
        },
        callback: this.afterLoadServices
      })
    } else {
      return CustomNotification(NOTIFICATION_TYPE.DANGER, "", t("invalidSearchValue"), t)
    }
    this.setState({ page: 1 })
  }

  goToFirstPage = () => {
    const currentPage = this.state.page

    if (currentPage !== 1) {
      this.handlePageChange({ newPage: 1 })
    }
  }

  goToPreviousPage = () => {
    const currentPage = this.state.page
    if (currentPage > 1) {
      this.handlePageChange({ newPage: currentPage - 1 })
    }
  }

  goToNextPage = () => {
    const currentPage = this.state.page
    if (currentPage < Math.ceil(this.props.totalFleetCount / 50)) {
      this.handlePageChange({ newPage: currentPage + 1 })
    }
  }

  goToLastPage = () => {
    const totalPage = Math.ceil(this.props.totalFleetCount / 50)
    const currentPage = this.state.page

    if (currentPage !== totalPage) {
      this.handlePageChange({ newPage: totalPage })
    }
  }

  handleChange = (e, data) => {
    this.setState({ searchByAccountNumber: data.checked })
  }

  render() {
    const { fleets, t, fleetsLoading } = this.props
    const { searchByAccountNumber } = this.state
    return (
      <Segment
        className={"ag-theme-material"}
        style={{
          height: agGridHelpers.dynamicGridHeight({ items: fleets })
        }}
      >
        <Input
          className="search"
          icon="search"
          onChange={this.onTextChange}
          placeholder="Search fleet..."
        />
        <Button
          disabled={!(this.state.search_text.length >= 1)}
          onClick={() => this.onSearch()}
          className={isFleetAdvise() ? "search-margin" : ""}
        >
          Search
        </Button>
        {getSubdomain() === FLEETCOR && (
          <Checkbox
            label="Search by Corpay account #"
            checked={searchByAccountNumber}
            onChange={this.handleChange}
          />
        )}

        {fleetsLoading ? (
          <FMCTransactionsShimmer />
        ) : (
          <>
            <AgGridReact
              columnDefs={agGridColumnDefs(this.defaultCellRenderer, t)}
              defaultColDef={{
                sortable: true,
                filter: true,
                headerComponentParams: {
                  template:
                    '<div class="ag-cell-label-container" role="presentation">' +
                    '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                    '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                    '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
                    '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
                    '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
                    '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
                    '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
                    '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                    "  </div>" +
                    "</div>"
                }
              }}
              gridOptions={{
                onFilterChanged: this.setFilteredItems
              }}
              onGridReady={this.onGridReady}
              rowData={agGridRowData(fleets)}
              rowSelection={"single"}
              frameworkComponents={{
                customNoRowsOverlay: CustomNoRowsOverlay,
                customLoadingOverlay: CustomLoadingOverlay
              }}
              noRowsOverlayComponent={"customNoRowsOverlay"}
              noRowsOverlayComponentParams={{
                translationFile: "fleets",
                label: "noFleetsLabel"
              }}
              cacheQuickFilter={true}
              pagination={false}
              paginationPageSize={agGridHelpers.PAGINATION_AMOUNT}
              suppressMenuHide={true}
              suppressMovableColumns={false}
              suppressCellSelection={true}
              loadingOverlayComponent={"customLoadingOverlay"}
              loadingOverlayComponentParams={{
                loadingMessage: t("oneMomentPlease")
              }}
            ></AgGridReact>
            <div className="ag-paging-panel ag-unselectable">
              <span className="ag-paging-row-summary-panel" aria-hidden="true">
                {(this.state.page - 1 || 0) * 50 + 1} to{" "}
                {Math.min(((this.state.page - 1 || 0) + 1) * 50, this.props.totalFleetCount)} of{" "}
                {this.props.totalFleetCount}
              </span>
              <span className="ag-paging-page-summary-panel" role="presentation">
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToFirstPage}
                  aria-label="First Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-first" role="presentation"></span>
                </div>
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToPreviousPage}
                  aria-label="Previous Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-previous" role="presentation"></span>
                </div>
                <span className="ag-paging-description" aria-hidden="true">
                  Page <span className="ag-paging-number">{this.state.page}</span> of{" "}
                  <span className="ag-paging-number">
                    {Math.ceil(this.props.totalFleetCount / 50)}
                  </span>
                </span>
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToNextPage}
                  aria-label="Next Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-next" role="presentation"></span>
                </div>
                <div
                  className="ag-paging-button"
                  role="button"
                  onClick={this.goToLastPage}
                  aria-label="Last Page"
                  tabIndex="0"
                >
                  <span className="ag-icon ag-icon-last" role="presentation"></span>
                </div>
              </span>
            </div>
          </>
        )}
      </Segment>
    )
  }
} // class FleetList

export default withRouter(withTranslation("fleets")(FleetList))
